const menus = document.querySelectorAll('[data-product-sticky-menu]');

const getHeaderHeight = () => {
    const header = document.querySelector('[data-header]');
    if (header) {
        return header.getBoundingClientRect().height;
    }

    const value = getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
        .trim();

    return value ? parseFloat(value) || 0 : 0;
};

const getScrollOffset = () => {
    return getHeaderHeight() + 84;
};

const ACTIVE_PROBE_OFFSET = 140;

const scrollToSection = (section) => {
    if (!section) return;

    const align = (behavior = 'smooth') => {
        const offset = getScrollOffset();
        const top = section.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: Math.max(0, top),
            behavior,
        });
    };

    align('smooth');
    // Header height can change during smooth scrolling (top bar hide/show),
    // so we do a lightweight correction pass after animation starts/ends.
    window.setTimeout(() => align('auto'), 320);
    window.setTimeout(() => align('auto'), 640);
};

const setActiveLink = (links, activeId) => {
    links.forEach(link => {
        const activeClasses =
            link.getAttribute('data-active-classes') || '';
        const inactiveClasses =
            link.getAttribute('data-inactive-classes') || '';
        const href = link.getAttribute('href') || '';
        const isActive = activeId && href === `#${activeId}`;

        if (activeClasses) {
            activeClasses.split(' ').forEach(cls => {
                if (cls) link.classList.toggle(cls, isActive);
            });
        }
        if (inactiveClasses) {
            inactiveClasses.split(' ').forEach(cls => {
                if (cls) link.classList.toggle(cls, !isActive);
            });
        }

        if (isActive) {
            link.setAttribute('aria-current', 'page');
        } else {
            link.removeAttribute('aria-current');
        }
    });
};

menus.forEach(menu => {
    const links = Array.from(
        menu.querySelectorAll('[data-product-sticky-link]')
    );
    if (!links.length) return;

    const targets = links
        .map(link => {
            const href = link.getAttribute('href') || '';
            if (!href.startsWith('#')) return null;
            const id = href.slice(1);
            const section = document.getElementById(id);
            return section ? { id, section } : null;
        })
        .filter(Boolean);

    if (!targets.length) return;

    let menuOffsetTop = 0;
    let headerHeight = 0;
    let lastAppliedTop = -1;
    let targetAnchors = [];

    const recalculateMetrics = () => {
        headerHeight = getHeaderHeight();
        menuOffsetTop = menu.getBoundingClientRect().top + window.scrollY;
        targetAnchors = targets.map(({ id, section }) => ({
            id,
            top: section.getBoundingClientRect().top + window.scrollY,
        }));
    };

    const updateActive = () => {
        const offset = headerHeight + 84;
        const probeLine = offset + ACTIVE_PROBE_OFFSET;
        const viewportProbeLine = window.scrollY + probeLine;
        let activeId = targetAnchors[0]?.id || targets[0].id;
        targetAnchors.forEach(({ id, top }) => {
            if (top <= viewportProbeLine) {
                activeId = id;
            }
        });
        setActiveLink(links, activeId);
    };

    const updateMenuTop = () => {
        if (headerHeight !== lastAppliedTop) {
            menu.style.top = `${headerHeight}px`;
            lastAppliedTop = headerHeight;
        }
    };

    const updateShadow = () => {
        const isStuck = window.scrollY + headerHeight + 1 >= menuOffsetTop;
        menu.style.boxShadow = isStuck
            ? '0 6px 18px rgba(15,23,42,0.08)'
            : 'none';
    };

    recalculateMetrics();
    updateMenuTop();
    updateActive();
    updateShadow();

    links.forEach(link => {
        link.addEventListener('click', event => {
            const href = link.getAttribute('href') || '';
            if (!href.startsWith('#')) return;
            event.preventDefault();
            const id = href.slice(1);
            const section = document.getElementById(id);
            setActiveLink(links, id);
            scrollToSection(section);
            if (window.history && window.history.replaceState) {
                window.history.replaceState(null, '', `#${id}`);
            }
        });
    });

    let rafId = null;
    const scheduleUpdate = () => {
        if (rafId !== null) {
            return;
        }
        rafId = window.requestAnimationFrame(() => {
            rafId = null;
            const nextHeaderHeight = getHeaderHeight();
            if (nextHeaderHeight !== headerHeight) {
                headerHeight = nextHeaderHeight;
            }
            updateMenuTop();
            updateActive();
            updateShadow();
        });
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', () => {
        recalculateMetrics();
        updateMenuTop();
        updateActive();
        updateShadow();
    });
});
